import { Yup } from '@elotech/components';

const ValidationSchemaUsuarioFuncionario = Yup.object().shape({
  matricula: Yup.string().required('Matrícula é obrigatória'),
  cargo: Yup.string().required('Cargo é obrigatório'),
  lotacao: Yup.string().required('Lotação é obrigatória'),
  situacao: Yup.string().required('Situação é obrigatória'),
  entidade: Yup.object().required('Entidade é obrigatória')
});

export default ValidationSchemaUsuarioFuncionario;
